import { soldGoodsRoutes } from '../sold-goods-routes';

export type ExcludedItemType = 'uncertain' | 'other';

interface ExcludedItemConfig {
  type: ExcludedItemType;
  title: string;
  /** 1–2 sentence explainer rendered beneath the page title. */
  description: string;
}

export const excludedItemsConfig: Record<ExcludedItemType, ExcludedItemConfig> =
  {
    uncertain: {
      type: 'uncertain',
      title: 'Items for review',
      description:
        'These items could not be identified or were missing information required to assess them accurately. Review and action these to increase your emissions coverage.',
    },
    other: {
      type: 'other',
      title: 'Other goods',
      description:
        'These items have been identified as neither food nor packaging and thus they cannot be assessed by our system. Other goods typically include things like cleaning products, toiletries or kitchenware.',
    },
  };

/** Route per category type. Read lazily (inside callers) to avoid a
 *  circular-import temporal-dead-zone on `soldGoodsRoutes`. */
export const excludedItemsHref = (type: ExcludedItemType): string =>
  ({
    uncertain: soldGoodsRoutes.SOLD_EXCLUDED_ITEMS_UNCERTAIN,
    other: soldGoodsRoutes.SOLD_EXCLUDED_ITEMS_OTHER,
  })[type];
